import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import styles from "./Loader.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

const Loader = ({ noShadow = false }) => (
  <div className={formatClassNames(styles.container, noShadow && styles.noShadow)}>
    <div className={formatClassNames(styles.dot, styles.dot1)} />
    <div className={formatClassNames(styles.dot, styles.dot2)} />
    <div className={formatClassNames(styles.dot, styles.dot3)} />
  </div>
);

export default wrapperHOC(Loader, {
  componentName: "Loader",
  showForChina: true,
});
